import { useState } from 'react';
import { FAQ_LEFT, FAQ_RIGHT, FALLBACK_MOANA } from './moana-data';
import { Eyebrow } from './MoanaHero';

const FaqColumn = ({ items, openFaq, setOpenFaq, offset }) => (
  <div className="border border-gray-200">
    {items.map((item, i) => {
      const idx = i + offset;
      const isOpen = openFaq === idx;
      return (
        <div key={idx} className="border-b border-gray-100 last:border-0">
          <button
            onClick={() => setOpenFaq(isOpen ? null : idx)}
            className="w-full flex items-center justify-between gap-4 p-5 text-left text-sm font-semibold text-[#1F2937] hover:bg-slate-50 transition-colors leading-snug"
            data-testid={`faq-q-${idx}`}
          >
            {item.q}
            <span className={`text-xl text-[#F59E0B] font-light flex-shrink-0 transition-transform ${isOpen ? 'rotate-45' : ''}`}>+</span>
          </button>
          {isOpen && (
            <div className="px-5 pb-4 text-sm text-gray-500 leading-relaxed">{item.a}</div>
          )}
        </div>
      );
    })}
  </div>
);

export const MoanaFaq = ({ cms }) => {
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <section id="faq" className="py-20 bg-white" data-testid="faq-section">
      <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="mb-11">
          <Eyebrow>Questions fréquentes</Eyebrow>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1F2937]">
            Tout savoir sur <em className="italic text-[#F59E0B]">Moana Paye</em>
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-0">
          <div className="md:border-r-0 md:rounded-l-xl md:rounded-r-none rounded-t-xl md:rounded-t-none md:rounded-tl-xl overflow-hidden">
            <FaqColumn items={cms.faq?.left || FAQ_LEFT} openFaq={openFaq} setOpenFaq={setOpenFaq} offset={0} />
          </div>
          <div className="md:rounded-r-xl md:rounded-l-none rounded-b-xl md:rounded-b-none md:rounded-br-xl overflow-hidden border-t-0 md:border-t">
            <FaqColumn items={cms.faq?.right || FAQ_RIGHT} openFaq={openFaq} setOpenFaq={setOpenFaq} offset={4} />
          </div>
        </div>
      </div>
    </section>
  );
};
